<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="PAs:"
    id="selectPA"
    placeholder="Selecione o(s) PA(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import PARepository from '../../../../shared/http/repositories/configurations/pa'

export default {
  name: 'NxSelectPA',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadPAs()
  },
  methods: {
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          // Filtrar PAs válidos (com numero e descricao não nulos)
          let validPAs = response.data.content.filter(pa =>
            pa.numero !== null &&
            pa.numero !== undefined &&
            pa.descricao !== null &&
            pa.descricao !== undefined &&
            pa.descricao.trim() !== ''
          )

          let result = validPAs
            .map((x) => ({'value': x.numero, 'text': x.descricao + ' - ' + x.numero}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de PAs', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectPAAtendimento.vue